import { SoggettoDTO } from "../soggettoDTO";
import { SoggettoAnagrafeDTO } from "./soggetto-anagrafeDTO";
import { SoggettoRicercaDTO } from "./soggetto-ricercaDTO";

export class FiltroRicercaSoggettoDTO {
  filtroTesto: string;
  filtroRicerca: SoggettoRicercaDTO;
  soloAttivi: boolean;
}
